import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { TextField } from "@mui/material";
import {
  forgotPasswordGenerateOtp,
  setUserName,
} from "../../actions/authActions";
import PlanetCard from "../PlanetCard/PlanetCard";
import "./ForgotPassword.scss";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch } from "react-redux";
import { toastMessage } from "../../helper";
import { EMAIL_REGEX } from "../../constants/regexConstants";
import { useTranslation } from "react-i18next";

const ForgotPassword = (props: any) => {
  const { t, i18n } = useTranslation();
  // const toastMessage = (message: string) => {
  //   toast(message);
  // };
  // const initState = {
  //     email: '',
  //     otp:'',
  //     password: '',
  //     confirmPassword:''
  // }
  // const [formData, setFormData] = useState(initState);
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const navigateToVerifyAccount = () => {
    // 👇️ navigate to /contacts
    navigate("/verifyaccount");
  };
  const navigateToSignin = () => {
    // 👇️ navigate to /contacts
    navigate("/auth/login");
  };
  const validateForm = () => {
    return email && !emailError && !isLoading;
  };

  const onChange = (e: any) => {
    setEmail(e.target.value);
    if (e.target.type === "email") {
      validateEmail(e.target.value);
    }
  };
  const validateEmail = (email: string) => {
    setEmailError("");
    if (email) {
      //regex mail
      if (!EMAIL_REGEX.test(email)) {
        setEmailError("Invalid Email");
      }
    }
  };
  // const sendToast = (message:string) => toast(message);

  const onSubmit = async (e: any) => {
    e.preventDefault();
    if (validateForm()) {
      setIsLoading(true);
      setUserName(email);
      dispatch(setUserName(email));
      localStorage.setItem("userName", email);
      forgotPasswordGenerateOtp(email)
        .then(() => {
          navigateToVerifyAccount();
          setIsLoading(false);
        })
        .catch((err) => {
          setIsLoading(false);
          toastMessage(err?.response?.data?.message, "error");
          console.log(
            "Error:",
            err.response && err.response.data && err.response.data.message
          );
        });
    }

    // if (password !== password2) {
    //setAlert('Passwords do not match', 'danger');
    // } else {
    //register({ name, email, password });

    // }
  };

  return (
    <div className="flex">
      <PlanetCard />
      <div className="flex flex-col w-40v pw-padding-4 pw-height-100v pw-overflow-y-auto">
        <div className="pw-tab-label">Forgot Password</div>
        <div className="pw-forgot-desc pw-input-label">
          Enter your email address below to receive instructions on how to reset
          your password
        </div>
        <div className="">
          <div className="pw-input-label">{t("Email Address")}</div>
          <TextField
            type="email"
            variant="outlined"
            placeholder={t("Enter your Mail ID")}
            size="small"
            name="email"
            className="pw-width-100 pw-input-field"
            value={email}
            onChange={(e) => onChange(e)}
          />
          {emailError ? (
            <span className="pw-display-error">* {emailError}</span>
          ) : (
            ""
          )}
        </div>

        <button
          type="button"
          className={`mt-7  pw-cursor-pointer pw-e2e-sendotpbtn ${
            validateForm() ? "pw-send-otp-active" : "pw-send-otp-inactive"
          } `}
          onClick={(e) => onSubmit(e)}
        >
          Send OTP
        </button>
        <button
          type="button"
          className="pw-back-to-signin pw-cursor-pointer pw-width-100"
          onClick={navigateToSignin}
        >
          Back To Sign In
        </button>
      </div>
    </div>
  );
};

export default ForgotPassword;
